import { render } from "./SGKRate.vue?vue&type=template&id=5f81b3f0"
import script from "./SGKRate.vue?vue&type=script&lang=js"
export * from "./SGKRate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__